import { useEffect, useState } from 'react';
import { useGlobal } from '../../hooks';
import { useFilter, useJobList, useMap } from 'rwl-ui';
import { useFetchInfiniteJobs } from './useFetchJobs';
import { isEmpty } from 'rwl-shared/dist/utils/string';

export const JobFetcher = (): null => {
    const { accountId, isReady, config } = useGlobal();
    const { appliedFilters } = useFilter();
    const { bounds, clearBounds } = useMap();
    const [initialBounds, setInitialBounds] = useState<string | undefined>();
    const {
        setJobList,
        setTotalJobs,
        setHasMoreJobs,
        setFetchNextPage,
        setIsLoading,
        jobList,
    } = useJobList();
    const { data, hasNextPage, fetchNextPage, isLoading, isFetchingNextPage } =
        useFetchInfiniteJobs({
            accountId: accountId,
            filters: appliedFilters,
            enabled: isReady,
            bounds,
            showcaseOnly: config?.extraData?.showcaseOnly,
        });

    // If our default bounds return no jobs,
    // clear the bounds to fetch jobs for the entire account
    useEffect(() => {
        if (!initialBounds && !isEmpty(bounds)) {
            // Only set the initial bounds once
            setInitialBounds(bounds);
        }
        const isInitialRenderWithBounds =
            !isEmpty(bounds) && initialBounds === bounds;
        if (isReady && isInitialRenderWithBounds && jobList.length === 0) {
            clearBounds();
        }
    }, [isReady, bounds, jobList]);

    useEffect(() => {
        if (data?.pages?.length) {
            const workSitesFromAllPages = data.pages
                .map((p) => p.workSites)
                .flat();
            const totalJobs = data.pages[0].count;
            setJobList(workSitesFromAllPages);
            setTotalJobs(totalJobs);
        }
    }, [data]);
    useEffect(() => {
        setHasMoreJobs(!!hasNextPage);
        setFetchNextPage(fetchNextPage);
    }, [hasNextPage, fetchNextPage]);

    useEffect(() => {
        setIsLoading(isLoading || (isFetchingNextPage && !!hasNextPage));
    }, [isLoading, isFetchingNextPage]);

    return null;
};
